import React, { Component } from 'react'
import styles from "./Toast.module.css";

interface Props {
  toastTxt: string,
  onHide:Function
}

class Toast extends Component<Props> {

  timer: any

  constructor(props: Props) {
    super(props)
    this.timer = null
  }

  componentDidMount() {
    this.timer && clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.props.onHide()
    }, 2000)
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.toastTxt && this.props.toastTxt!==nextProps.toastTxt) {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        nextProps.onHide()
      }, 2000)
    }
  }

  componentWillUnmount() {
    this.timer && clearTimeout(this.timer)
    const { onHide } = this.props
    onHide()
  }

  render() {
    const { toastTxt } = this.props
    return (
      <React.Fragment>
        {toastTxt &&
          <div className={styles.toast}>{toastTxt || "网络异常，请稍后重试"}</div>
        }
      </React.Fragment>
    )
  }
}

export default Toast
